export default "__VITE_ASSET__DpJOdUHF__"